import { render } from "./Jabatan.vue?vue&type=template&id=1c9b4556"
import script from "./Jabatan.vue?vue&type=script&lang=js"
export * from "./Jabatan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__